import React from 'react';
import './header.scss';
// import { SocialSharing } from '@marketing/web-dev-react-components';
import Svgs from '../../resources/svgs';

const Header = (props) =>
  <div className="tapestry-header">
    <a href="https://www.esri.com" className="tapestry-header--logo">{Svgs.esriLogo}</a>
    <span className="tapestry-header--title">
      {props.title}
      <sup>SM</sup>
    </span>
    {/* <SocialSharing /> */}
  </div>
  ;
export default Header;
